import { api } from "../config/api";
import { toIsoUtc } from "../utils/dateUtils";

export const createJob = async (companyId, data) => {
  const payload = {
    title: data.title,
    description: data.description,
    location: data.location,
    date: data.date,
    startTime: data.startTime,
    endTime: data.endTime || null,
    payment: data.payment ?? 0,
    visibility: data.visibility || 'public',
    isUrgent: data.isUrgent ?? false,
    contactPerson: data.contactPerson || null,
    breakTime: data.breakTime || null,
    dressCode: data.dressCode || null,
    privateSlug: data.privateSlug || null,
    publishStatus: data.publishStatus || 'published',
    scheduledPublishAt: data.scheduledPublishAt
      ? toIsoUtc(data.scheduledPublishAt)
      : null,
    customQuestions: data.customQuestions || [],
    batchId: data.batchId || null,
  };

  const response = await api.post(`/Jobs/${companyId}`, payload);
  return response.data;
};

export const loadJobs = async (companyId) => {
  const response = await api.get(`/Jobs/company/${companyId}`);
  return response.data;
};

export const editJob = async (jobId, data) => {
  const payload = {
    title: data.title,
    description: data.description,
    location: data.location,
    date: data.date,
    startTime: data.startTime,
    endTime: data.endTime || null,
    payment: data.payment ?? 0,
    visibility: data.visibility || 'public',
    isUrgent: data.isUrgent ?? false,
    contactPerson: data.contactPerson || null,
    breakTime: data.breakTime || null,
    dressCode: data.dressCode || null,
    privateSlug: data.privateSlug || null,
    publishStatus: data.publishStatus || 'published',
    scheduledPublishAt: data.scheduledPublishAt || null,
    customQuestions: data.customQuestions || [],
    batchId: data.batchId || null,
  };

  const response = await api.put(`/Jobs/${jobId}`, payload);
  return response.data;
};

export const deleteJob = async (jobId) => {
  await api.delete(`/Jobs/${jobId}`);
};

export const getPublicJobs = async () => {
  const userId = localStorage.getItem("userId");
  const response = await api.get("/Jobs", {
    params: userId ? { freelancerId: userId } : {},
  });
  return response.data;
};

export const loadPrivateJob = async (slug) => {
  const response = await api.get(`/Jobs/private/${slug}`);
  return response.data;
};

export const addExtraHours = async (jobId, hours) => {
  const response = await api.put(`/Jobs/${jobId}/extra-hours`, { hours });
  return response.data;
};

export const closeJobsInProgress = async (id) => {
  const response = await api.put(`/Jobs/close-job/${id}`);
  return response.data;
};